import { DestroyRef, Directive, effect, inject, input, signal } from '@angular/core';
import { DocumentViewerConsultantService } from '../document-viewer-consultant.service';
import { FormGroup, NonNullableFormBuilder } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive()
export abstract class DocumentFormBase<TForm extends FormGroup, TValue = TForm['value']> {
  protected readonly fb = inject(NonNullableFormBuilder);
  protected readonly documentViewerService = inject(DocumentViewerConsultantService);

  readonly codeConsultant = input<string>();

  protected readonly value = signal<TValue | undefined>(undefined);
  protected readonly form: TForm;
  protected readonly isFormEmit = signal<boolean>(true);
  protected readonly isInit = signal<boolean>(false);

  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.form = this.createForm(this.fb);

    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((value: TValue) => {
        if (this.isFormEmit()) {
          this.documentViewerService.setDocumentFormValue(value);
          this.documentViewerService.setDocumentFormValidity(this.form.valid);
          this.value.set(value);
        } else {
          this.isFormEmit.set(true);
        }
      });

    effect(() => {
      const initial = this.documentViewerService.documentFormValue();
      const hasData = this.documentViewerService.documentFormLoadedFromValPj();

      if (initial && typeof initial === 'object' && hasData && !this.isInit()) {
        this.isFormEmit.set(false);
        this.isInit.set(true);
        this.form.patchValue(initial);
        this.documentViewerService.setDocumentFormValidity(this.form.valid);
      }
    });
  }

  protected abstract createForm(fb: NonNullableFormBuilder): TForm;
}
